import { ApolloLink, NextLink, Operation, RequestHandler } from "apollo-link";
import { HttpLink } from "apollo-link-http";
import { removeDirectivesFromDocument, hasDirectives } from "apollo-utilities";

import { StringValueNode, OperationDefinitionNode } from "graphql";
import { GRAPHQL_ADX_URI, GRAPHQL_COSMOSDB_URI } from "./configs";

class MultiAPILink extends ApolloLink {
  httpLink: ApolloLink;
  constructor(request?: RequestHandler) {
    super(request);
    this.httpLink = new HttpLink({
      headers: {
        Authorization: `Bearer ${this.getAndParseTokenFromStorage()}`,
      },
    });
  }

  private getAndParseTokenFromStorage(): string {
    const authToken = localStorage.getItem("token");
    return authToken;
  }

  public request(operation: Operation, forward: NextLink) {
    if (!hasDirectives(["api"], operation.query)) {
      return forward(operation);
    }

    const apiName: string = (
      (
        operation.query.definitions.find(
          (definition) => definition.kind === "OperationDefinition"
        ) as OperationDefinitionNode
      )?.directives
        ?.find((directive) => directive.name?.value === "api")
        ?.arguments?.find((argument) => argument.name?.value === "name")
        ?.value as StringValueNode
    )?.value;

    const query = removeDirectivesFromDocument(
      [{ name: "api", remove: true }],
      operation.query
    );
    if (!query) {
      throw new Error("Error while removing directive api");
    }

    operation.query = query;

    switch (apiName) {
      case "cosmos":
        operation.setContext({
          uri: GRAPHQL_COSMOSDB_URI,
          headers: {
            Authorization: `Bearer ${this.getAndParseTokenFromStorage()}`,
          },
        });
        break;
      case "adx":
        operation.setContext({
          uri: GRAPHQL_ADX_URI,
          headers: {
            Authorization: `Bearer ${this.getAndParseTokenFromStorage()}`,
          },
        });
        break;
    }
    return this.httpLink.request(operation, forward);
  }
}

export default MultiAPILink;
